var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-table',{ref:"mytable",attrs:{"height":_vm.height,"id":"mytable","columns":_vm.columns,"tableData":_vm.list,"indexHidden":"","notPagination":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }